'use strict';

/* eslint-disable */ function getFragmentData(_documentNode, fragmentType) {
    return fragmentType;
}

exports.getFragmentData = getFragmentData;
